<template>
    <div class="add-edit-profile-image">
        <div class="avatar-container">
            <div class="avatar-image">
                <myUpload field="img"
                    @crop-success="cropSuccess"
                    v-model="show"
                    :width="300"
                    :height="300"
                    :noSquare="noSqaure"
                    :langExt="lang"
                    img-format="png"></myUpload>
                <img v-show="imgDataUrl != ''" class="preview" :src="imgDataUrl">
                <input type="file" class="cropit-image-input" id="profile_avatar" name="image_change" style="display: none;" @change="uploadImage"/>
                <div class="uploadfileinfo">
                    Supported file types: jpeg, png
                </div>
                <label for="file-upload" class="custom-file-upload" id="profile_file_trigger" @click="toggleShow">
                    <i class="fas fa-plus-circle"></i> 
                    <span>Upload Logo*</span>
                </label>
            </div>
        </div>
        <FormError :validationStatus="validation"/>
    </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload';
import Eng from './AvatarUploadEng';
import FormError from './FormError.vue';
export default {
    components: {myUpload, FormError},
    props: ['imageUrl', 'validation'],
    emits: ["callback"],
    data(){
        return{
            show: false,
			headers: {
				smail: '*_~'
			},
            fileTypes: ['jpg', 'jpeg', 'png'],
            imgDataUrl: this.imageUrl,
            cropImg: "",
            lang: Eng,
            noSqaure: true
        }
    }, 
    methods:{
        toggleShow() {
				this.show = !this.show;
			},
            /**
             * More can be found - https://github.com/dai-siki/vue-image-crop-upload
			 * crop success
			 *
			 * [param] imgDataUrl
			 * [param] field
			 */
			cropSuccess(imgDataUrl, field){
				this.imgDataUrl = imgDataUrl;
                this.$emit('callback', this.imgDataUrl);
			},
    },
}
</script>
